import { Grid } from '@mui/material';
import type { GridProps } from '@mui/material';
import type { PpWC } from '@noah-labs/fe-shared-ui-shared';

export type PpFormGrid = Pick<GridProps, 'spacing' | 'sx'> & PpWC;

export function FormGrid({ children, spacing = 2.5, sx }: PpFormGrid): React.ReactElement {
  return (
    <Grid container spacing={spacing} sx={sx}>
      {children}
    </Grid>
  );
}
